import type { DocusignEnvelope } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface CreateDocusignEnvelopeParams {
  document_filler_run_id: string
  return_url?: string
  email_subject?: string
  email_message?: string
  signers: {
    role: string
    name: string
    email: string
    phone_number?: string
    person_id?: string
    user_id?: string
  }[]
  delegated_fields?: {
    field_key: string
    signer_role: string
    required: boolean
  }[]
}

export async function downloadDocusignEnvelope(
  context: ApiContext,
  householdId: string,
  envelopeId: string
): Promise<{ url: string }> {
  return apiContextFetch<{ url: string }>(
    context,
    `households/${householdId}/docusign_envelopes/${envelopeId}/download`
  )
}

export async function createDocusignEnvelope(
  context: ApiContext,
  householdId: string,
  params: CreateDocusignEnvelopeParams
): Promise<DocusignEnvelope> {
  return apiContextFetch<DocusignEnvelope>(context, `households/${householdId}/docusign_envelopes`, {
    method: "POST",
    body: JSON.stringify(params),
  })
}
